import { EntityLinks, Goal, ID } from '@griply/types';

import { getGoalParentIds } from './get-goal-parents';

export type GetGoalAncestorIdsOptions = {
  goalsById: Map<ID, Goal>;
  links: EntityLinks;
};

// Root first, direct parent last — the shape `ancestorIds` had, which a migrated goal no longer carries.
export const getGoalAncestorIds = (
  goal: Goal,
  { goalsById, links }: GetGoalAncestorIdsOptions,
  visited: Set<ID> = new Set([goal.id]),
): ID[] => {
  const parentId = getGoalParentIds(goal, { links })[0];
  if (!parentId || visited.has(parentId)) {
    return [];
  }
  visited.add(parentId);

  const parent = goalsById.get(parentId);
  if (!parent) {
    return [parentId];
  }

  return [
    ...getGoalAncestorIds(parent, { goalsById, links }, visited),
    parentId,
  ];
};
